import { snakeCaseToTitleCase } from "common/utils/strings";
import BuilderOptionModal from "lib/components/builders/communities/plans/modals/BuilderOptionModal";
import { planLibraryActions } from "lib/components/builders/plan-library/planLibraryReducer";
import { usePlanLibraryDispatch, usePlanLibrarySelector } from "lib/components/builders/plan-library/planLibraryStore";
import usePlanLibraryEvents from "lib/components/builders/plan-library/usePlanLibraryEvents";
import useAppContext from "ui/hooks/useAppContext";
import { Message } from "ui/text/Message";

export default function PlanLibraryDiscardAllOverridesModal() {
  const { discardAllOverrides, searchFor, planType, planName } = usePlanLibrarySelector((state) => {
    return {
      discardAllOverrides: state.discardAllOverrides,
      searchFor: state.searchFor,
      planType: state.plans.planType,
      planName: state.planName,
    };
  });

  const { setUserNotification } = useAppContext();
  const dispatch = usePlanLibraryDispatch();
  const sendPlanLibraryEvent = usePlanLibraryEvents();

  return (
    <BuilderOptionModal
      open={discardAllOverrides}
      onClose={() => dispatch(planLibraryActions.enableDiscardAllOverridesModal(false))}
      modalBody={
        <Message messageType="warning">
          <>
            Are you sure you want to discard all overrides for {planName}? This will undo any changes made to both
            option sets and elevations. <b>This action cannot be undone.</b>
          </>
        </Message>
      }
      submitButtonText="Discard"
      modalHeader={`Discard all Overrides for ${snakeCaseToTitleCase(planType)}`}
      submittable
      preventCloseOnSubmit
      onSubmit={() => {
        sendPlanLibraryEvent("config:discarded_all_overrides_for_plan");
        dispatch(planLibraryActions.discardAllOverridesForPlan());
        // preserve search filter which might have been set prior to discard all
        if (searchFor) {
          dispatch(planLibraryActions.setSearch(searchFor));
        }
        setUserNotification({
          message: `All overrides for ${planName} have been discarded`,
          messageType: "success",
        });
      }}
    />
  );
}
